/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FormDetail,
    FormDetailFromJSON,
    FormDetailFromJSONTyped,
    FormDetailToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface FormDetailResponse
 */
export interface FormDetailResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof FormDetailResponse
     */
    msg: string;
    /**
     * 
     * @type {FormDetail}
     * @memberof FormDetailResponse
     */
    entry: FormDetail;
}

export function FormDetailResponseFromJSON(json: any): FormDetailResponse {
    return FormDetailResponseFromJSONTyped(json, false);
}

export function FormDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormDetailResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': FormDetailFromJSON(json['entry']),
    };
}

export function FormDetailResponseToJSON(value?: FormDetailResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': FormDetailToJSON(value.entry),
    };
}


